import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router";

//Types
import { MakeCallDto } from "../../../dtos/Call/MakeCallDto";

//Events
import { EventBusEventsEnum } from "../../../enums/EventBusEventsEnum";
import EventBus from "../../../EventBus";

//Snack Bar
import { CustomSnackbarTypes } from "../CustomSnackBar";

//Icons
import { CallIcon } from "../../Svg";


//Services
import CallServices from "../../../services/CallServices";

//Store
import { setMakeCall } from "../../../store/reducers/callSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { CallPurposeEnum } from "./CallButton";

const callServices = new CallServices();
interface InputProps { 
  toPhoneNumber: string; 
  userType: string; 
  color?: string;
  size?: number;
  referenceId?: number; 
  referenceModelName?: string; 
}

function CustomCallIconButton(props: InputProps) {
  const [openCallingDialog, setOpenCallingDialog] = useState(false);
  const [holdApiCall, setHoldApiCall] = useState(false);
  const [dialogMessage, setDialogMessage] = useState<string>('');

  const userDetails = useAppSelector((state) => state.userDetails.value);
  const makeCallValue = useAppSelector((state) => state.makeCall.makeCall);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleOnClick = () => {
    if (!userDetails?.adminUser?.mobile) {
      navigate(`/AdminUsers/${userDetails?.adminUser?.id}`);
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Phone No required",
        type: CustomSnackbarTypes.ERROR,
      });
      return;
    }

    setOpenCallingDialog(true);
  };

  const handlePurposeSelect = (purpose: string) => {
    if (!makeCallValue || holdApiCall) {
      EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
        message: "Already a call in progress. Please wait.",
        type: CustomSnackbarTypes.WARNING,
      });
      return;
    }

    setDialogMessage(`Connecting your call...`);
    const payload: MakeCallDto = {
      from: userDetails?.adminUser?.mobile!,
      to: props.toPhoneNumber,
      userType: props.userType,
      purpose,
      referenceId: props.referenceId,
      referenceModelName: props.referenceModelName,
      initiatedBy: userDetails?.adminUser?.id!,
      initiatedByType: "ADMIN",
    };

    setHoldApiCall(true);

    callServices
      .makeCall(payload)
      .then(() => {
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Please wait while we connect your call.",
          type: CustomSnackbarTypes.SUCCESS,
        });

        dispatch(setMakeCall({ makeCall: false }));

        setTimeout(() => {
          setHoldApiCall(false);
          dispatch(setMakeCall({ makeCall: true }));
        }, 10000);
      })
      .catch(() => {
        setHoldApiCall(false);
        EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
          message: "Failed to initiate call",
          type: CustomSnackbarTypes.ERROR,
        });
      });
  };

  return (
    <div>
      <Box 
        sx={{ cursor: "pointer", display: "flex" }}
        onClick={(e) => {
          e.stopPropagation();
          handleOnClick();
        }}
      >
        <CallIcon 
          color={props.color || "#6C7C93"} 
          size={props.size || 18} 
        />
      </Box>

      <Dialog 
        open={openCallingDialog} 
        onClose={() => setOpenCallingDialog(false)}   
        onClick={(e) => e.stopPropagation()} 
      >
        <DialogContent sx={{ textAlign: "center", minWidth: 300 }}>
          {dialogMessage ? (
            <Typography>{dialogMessage}</Typography>
          ) : (
            <>
              <Typography mb={2}>Select Call Purpose</Typography>

              <Box display="flex" flexWrap="wrap" gap={1} justifyContent="center">
                {Object.values(CallPurposeEnum).map((purpose) => (
                  <Button
                    key={purpose}
                    variant="outlined"
                    color="success"
                    disabled={holdApiCall}
                    onClick={() => handlePurposeSelect(purpose)}
                    sx={{ minWidth: 120 }}
                  >
                    {purpose}
                  </Button>
                ))}
              </Box>
            </>
          )}
        </DialogContent>

        <DialogActions>
          <Button 
            onClick={() => {
              setOpenCallingDialog(false)
              setDialogMessage('')
            }}
            color="success"
            variant="contained"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default CustomCallIconButton;